<template>
  <div class="company-table-container">
    <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
      <b-table 
        :items="companyList"
        :fields="tableFields" 
        class="company-table gk-table--headed"
        :class="{ 'hide-scrollbar': hideScrollbar }"
        borderless hover sticky-header
        @row-clicked="selectCompany"
        :busy="loadingCompanies"
        show-empty
        table-busy>
        <template #empty="">
          <span class="empty-table-text" style="opacity: 0.5; font-size: 14px; text-align: center; display: block;">{{ $gettext('No companies found') }}. {{ $gettext('Try again with a different search term or contact the Chamber of Commerce.') }}</span>
        </template>
        <template #table-busy="">
          <b-skeleton-table :rows="4" :columns="2" :table-props="{ bordered: false }" :hide-header="true" />
        </template>
      </b-table>
    </overlay-scrollbars>
    
    <div v-show="showPaginationButtons" class="nav-btns">
      <GekkoButton 
        @click="loadResultsPage(prevPageLink)" 
        :text="$gettext('Prev')" 
        class="pagination-button primary text-blue" 
        icon="fa-solid fa-arrow-left"
        variant="link text-blue"
        :class="{ disabled : !prevPageLink }"
      />
      <div class="nav-separator">|</div>
      <GekkoButton 
        @click="loadResultsPage(nextPageLink)" 
        :text="$gettext('Next')" 
        icon-right
        icon="fa-solid fa-arrow-right"
        class="pagination-button text-blue"
        variant="link text-blue" 
        :class="{ disabled : !nextPageLink }"
      />
    </div>
  </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import CompanyService from "@/store/services/company.service";

export default {
  name: "KvkSuggestionsTable",
  components: {GekkoButton},
  props: {
    companyName: {
      type: String,
      default: ''
    },
    hideScrollbar: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      tableFields: [
        { key: "kvkNummer", label: this.$gettext('KVK')},
        { key: "naam", label: this.$gettext('Name')},
        { key: "plaats", label: this.$gettext('City')}
      ],
      companyList: [],
      prevPageLink: null,
      nextPageLink: null,
      loadingCompanies: true
    }
  },
  computed: {
    showPaginationButtons () {
      return this.companyList.length && (this.prevPageLink || this.nextPageLink)
    }
  },
  methods: {
    selectCompany (company) {
      this.$emit('companySelected', company)
    },
    getCompanyList () {
      this.loadingCompanies = true
      let params = { searchText: this.companyName }
      
      CompanyService.searchKvk(params).then((response) => {
        if (response.data) {
          this.processSearchResponse(response.data)
        }
        this.loadingCompanies = false
      }).catch(() => {
        this.$store.commit('setAlert', {
          title: this.$gettext("Error"),
          text: this.$gettext("We could not find any results from your search."),
          variant: "danger",
          duration: 4
        })
      })
    },
    processSearchResponse (data) {
      console.log('processSearchResponse', data)
      if (data.resultaten) {
        this.companyList = data.resultaten

        this.companyList = this.companyList.map(x => {
          if (x.adres && ('binnenlandsAdres' in x.adres)) {
            x.plaats = x.adres.binnenlandsAdres.plaats
            x.stratnaam = x.adres.binnenlandsAdres.stratnaam
          }
          return x
        })
        
        this.prevPageLink = data.vorige || null
        this.nextPageLink = data.volgende || null

      } else {
        this.companyList = []
      }
    },
    loadResultsPage (page_link) {
      if (page_link) {
        this.loadingCompanies = true
        CompanyService.getKvkPageByUrl({ url: page_link }).then((response) => {
          this.processSearchResponse(response.data)
          this.loadingCompanies = false
        })
      }
    },
    clearCompanyList () {
      this.companyList = [];
    }
  }
}
</script>

<style lang="scss">
.company-table-container {
  .os-host {
    border: 1px solid #c0c0c5;
    box-shadow: $dropdownShadow;
    border-radius: $radiusLg;
    // height: calc(100% - 36px) !important;
    height: 238px !important;
    .os-content { padding: 0 !important; }
    margin-bottom: 0.25rem !important;
  }
}

.company-table-container {
  flex: 1;
}

.company-table {
  cursor: pointer;
  font-size: 16px;
  min-height: 150px;
  overflow: visible !important;
  &.hide-scrollbar {
    max-height: 100%;
  }
  thead {
    font-size: 14px;
    tr {
      th {
        background: #f8f8f8 !important;

        &:first-child {
          border-top-left-radius: $radiusLg;
        }
        &:last-child {
          border-top-right-radius: $radiusLg;
        }
      }
    }
  }
  tr {
    th, td {
      padding: 0.5rem 0.75rem;
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid $colorBorderDash;
    }
  }
}

.nav-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    .nav-disabled { opacity: 0.4; }
    .nav-separator { opacity: 0.5; }
}
</style>